import React from 'react';

interface CustomImageSliderProps {
  images: { src: string; title: string }[];
  overallTitle?: string;
  className?: string;
  startIndex?: number; // 親から指定できる画像のインデックス
}

export const CustomImageSlider: React.FC<CustomImageSliderProps> = ({
  images,
  overallTitle,
  className,
  startIndex = 0,
}) => {
  // 指定されたインデックスの画像を取得（デフォルトは0）
  const selectedImage = images[startIndex];

  return (
    <div className={`relative ${className}`}>
      {selectedImage && (
        <div className="w-full h-full">
          <img
            src={selectedImage.src}
            alt={selectedImage.title}
            className="w-full h-full object-cover"
          />
          <div className="flex justify-between md:mt-2 md:px-4">
            <p className="text-left text-[9px]">{selectedImage.title}</p>
          </div>
        </div>
      )}
      <p className="text-[10px]">{overallTitle}</p>
    </div>
  );
};
